import { BehaviorSubject, distinctUntilChanged, takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IInventoryLocation } from '@inventory/models/inventory';
import { SwitchControlComponent } from '@shared/components/forms/switch-control/switch-control.component';
import { LoadingStateComponent } from '@shared/components/loading-state/loading-state.component';
import { NullDefaultPipe } from '@shared/pipes/null-default.pipe';

@Component({
	selector: 'app-desktop-inventory-locations-table',
	imports: [CommonModule, FormsModule, ReactiveFormsModule, SwitchControlComponent, LoadingStateComponent, NullDefaultPipe],
	templateUrl: './desktop-inventory-locations-table.component.html',
	styleUrl: './desktop-inventory-locations-table.component.scss',
	host: {
		class: 'h-100',
	},
})
export class DesktopInventoryLocationsTableComponent implements OnInit, OnDestroy {
	@Input() isLoading: boolean;
	@Input() locationItems: Array<IInventoryLocation>;
	@Input() showArchived$: BehaviorSubject<boolean>;
	@Output() inventoryLocationEdit = new EventEmitter<IInventoryLocation>();
	@Output() inventoryLocationViewItems = new EventEmitter<IInventoryLocation>();
	@Output() inventoryLocationArchive = new EventEmitter<IInventoryLocation>();
	@Output() inventoryLocationUnarchive = new EventEmitter<IInventoryLocation>();
	@Output() addNewEvent = new EventEmitter<void>();

	form: FormGroup<{ showArchived: FormControl }>;

	destroyed$ = new EventEmitter<void>();

	get showArchived(): FormControl<boolean> {
		return this.form.controls.showArchived;
	}

	ngOnInit(): void {
		this.form = new FormGroup({
			showArchived: new FormControl<boolean>(false),
		});

		this.showArchived.valueChanges.pipe(takeUntil(this.destroyed$), distinctUntilChanged()).subscribe((value) => {
			this.showArchived$.next(value);
		});
	}

	ngOnDestroy(): void {
		this.destroyed$.emit();
	}

	onInventoryLocationEdit(location: IInventoryLocation) {
		this.inventoryLocationEdit.emit(location);
	}

	onInventoryLocationViewItems(location: IInventoryLocation) {
		this.inventoryLocationViewItems.emit(location);
	}

	onInventoryLocationArchive(location: IInventoryLocation) {
		this.inventoryLocationArchive.emit(location);
	}

	onInventoryLocationUnarchive(location: IInventoryLocation) {
		this.inventoryLocationUnarchive.emit(location);
	}

	onAddNewClick() {
		this.addNewEvent.emit();
	}
}
